import { useQuery } from '@tanstack/vue-query';
import { computed } from 'vue';
import axios from 'axios';

export function useEconomicDimensionsData(companyId?: number) {
    const { data: dimensions, isPending, isFetching } = useQuery({
        queryKey: ['economic-dimensions', companyId],
        queryFn: async () => {
            const { data } = await axios.get(route('v2.voucher.dimensions.get', companyId));
            return data || [];
        },
        enabled: !!companyId,
        placeholderData: [],
        retry: 1,
        refetchOnMount: true,
    });

    const isPendingDimensions = computed(() => isPending.value || isFetching.value);

    return {
        dimensions,
        isPendingDimensions,
    };
}
